export default __webpack_public_path__ + "static/button-spacing-after.light-4df44c9ba0f0f9fede9e4a4229afc131c27646c1841610ce4cfed6c43e2978d9.png";